import React, { useEffect } from 'react';

import './Help.scss';
import style from './style.module.scss';
import { useSearchParams } from 'react-router-dom';

const UpdateAppInfo = () => {
  const [searchParams] = useSearchParams();
  const newVersion = searchParams.get('NewVersion') || false;

  const updateComesButCancelIt =
    localStorage.getItem('updateComesButCancelIt') === 'true' ? true : false;

  useEffect(() => {
    const appBar = document.getElementById('appBar');
    const helpContainer = document.getElementById('helpContainer');
    if (appBar) {
      appBar.classList.add('hideAppBar');
      helpContainer.classList.add('pageHeightOnRemoveAppBar');
    }
    return () => {
      appBar.classList.remove('hideAppBar');
      helpContainer.classList.remove('pageHeightOnRemoveAppBar');
    };
  }, []);

  return (
    <div>
      <div className={style.infoAboutVersion}>
        {newVersion || !updateComesButCancelIt ? (
          <>
            <p>
              You’re running the latest version: <span>1.5.3.0</span>
            </p>
          </>
        ) : (
          <>
            <p>
              You’re running the older version: <span>1.5.1.0</span>
            </p>
            <p
              style={{
                marginTop: '8px'
              }}
            >
              Refresh your data and follow the prompts to update the application.
            </p>
          </>
        )}
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.5.3.0</div>
        <div className={style.yearAndMonth}>OCTOBER 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fix</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            Oplii Mobile has been updated to address an issue with login expiration, as well as
            minor bug fixes.
          </div>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.5.1.0</div>
        <div className={style.yearAndMonth}>JUNE 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fix</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            Oplii Mobile has been updated to address an issue with equipment selection during the
            creation of an on-demand inspection, as well as minor photo syncing bug.
          </div>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.5.0.4</div>
        <div className={style.yearAndMonth}>May 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fix</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            Oplii Mobile has been updated for compatibility with newer Android devices in Google
            Play.
          </div>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.5.0.2</div>
        <div className={style.yearAndMonth}>APRIL 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fix</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This hotfix addresses a bug with syncing check form data.
          </div>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.5.0.0</div>
        <div className={style.yearAndMonth}>APRIL 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">UT Inspections</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '10px' }}>
            A new ultrasonic testing section can now be added to mobile inspection forms to capture
            corrosion readings and support end-of-life calculations in desktop Oplii.
          </div>

          <div className="whats-oplii-mobile--description" style={{ marginBottom: '10px' }}>
            Oplii Mobile prompts you to download data related to corrosion monitoring locations,
            specific to the equipment being inspected, when an assigned inspection form contains the
            <span className={style.boldText}> UT Information</span> section.
          </div>

          <div className="whats-oplii-mobile--description" style={{ marginBottom: '10px' }}>
            <span className={style.boldText}>
              Additional UT data must be downloaded prior to opening the form from an offline
              location.
            </span>{' '}
            It’s not automatically cached when Oplii Mobile refreshes, to avoid maxing out the app’s
            data stores.
          </div>

          <div className="whats-oplii-mobile--description" style={{ marginBottom: '10px' }}>
            If the inspection has been assigned to you, you’ll see the{' '}
            <span className={style.boldText}>Additional data required</span> tag on the task card.
            When you select one or more of these tasks, you will be prompted to download the data.
          </div>

          <div className="whats-oplii-mobile--description" style={{ marginBottom: '10px' }}>
            On-demand UT inspections, when launched while online, will also download any additional
            data required when started.
          </div>

          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This release also includes:
          </div>

          <ul className="leastClass">
            <li>
              A change to the photo upload/capture tools to allow for multiple photos to be added at
              a time, and
            </li>
            <li>Smaller bug fixes.</li>
          </ul>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.29.2</div>
        <div className={style.yearAndMonth}>March 2026</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This release fixed issues such as:
          </div>

          <ul className="leastClass">
            <li>Allowing for “0” (zero) entry on measurement fields.</li>
            <li>Photos downloads on assigned work orders.</li>
            <li>
              With some users still experiencing glitching and rebooting when filtering lists,
              completing tasks and syncing, we’ve made changes to further reduce memory usage within
              the app.
            </li>
          </ul>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.27.6</div>
        <div className={style.yearAndMonth}>NOVEMBER 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This was a small fix to address a big bug that stopped users from being able to scroll
            through longer task lists.
          </div>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.27.5</div>
        <div className={style.yearAndMonth}>NOVEMBER 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This is a minor release that addresses two major bugs:
          </div>

          <ul className="leastClass">
            <li>
              Some users were experiencing memory-use issues resulting in crashes/restarts, often
              during task completion, syncing and photo capture/upload.
            </li>
            <li>
              User location was not updating on a regular basis on Apple devices, leading to issues
              sorting lists by distance.
            </li>
          </ul>
        </div>
      </div>

      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.27.1</div>
        <div className={style.yearAndMonth}>October 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This is a minor release that addresses bugs to do with adding and editing equipment.
          </div>
        </div>
      </div>

      {/* section 1 */}
      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.27.0</div>
        <div className={style.yearAndMonth}>September 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Main feature: Add/edit equipment</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            You can now create new equipment from Oplii Mobile, as well as change existing equipment
            data.
            <div style={{ marginBottom: '10px' }}></div>
            On sync, your <span className={style.boldText}>New asset</span> and
            <span className={style.boldText}> Edited asset </span>
            records make their way to the{' '}
            <span className={style.boldText}>Equipment Reconciliation grid</span> in the Equipment
            module in desktop Oplii. From there, a reviewer will approve the suggested changes or
            creations before they’re realized in the organization’s asset database. It’s all about
            data integrity.
            <div style={{ marginBottom: '10px' }}></div>
            What’s more is when you create a new equipment record in Oplii Mobile, you can also
            create tasks (like inspections) associated to the new equipment{' '}
            <span className={style.boldText}>prior to syncing.</span>
            <div style={{ marginBottom: '10px' }}></div>
            Changes to PSV-vessel relationships are also editable from the vessel record. You can
            log detachments and attachments, as well as create new PSV records.
          </div>

          <div className="whats-oplii-mobile--title" style={{ marginTop: '16px' }}>
            The smaller stuff:
          </div>

          <ul className="leastClass">
            <li>
              The <span className={style.boldText}>Synced</span> tab will be automatically sorted by
              most recently synced,
            </li>
            <li>Small improvements to the interface,</li>

            <li>Changes to ‘Due Date’ and ‘Scheduled Date’ filters to include overdue work,</li>

            <li>And, finally, a number of bugs were fixed, of course.</li>
          </ul>
        </div>
      </div>

      {/* section 2 */}
      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.25.1</div>
        <div className={style.yearAndMonth}>March 2025</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Bug fixes</div>
          <div className="whats-oplii-mobile--description" style={{ marginBottom: '0px' }}>
            This is a minor release that addresses bugs to do with inspection and work order
            completion dates.
          </div>
        </div>
      </div>

      {/* section 3 */}
      <div
        className={`whats-oplii-mobile ${style.updateInfoContainer}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.23.0</div>
        <div className={style.yearAndMonth}>DECEMBER 2024</div>
        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Main feature: A new bundler</div>
          <div className="whats-oplii-mobile--description">
            OK. It’s not the most exciting, outwardly obvious update—but, it does mean big things
            for Oplii Mobile. We’ve changed the app from the bottom up to use a more modern storage
            method that will reduce the incidence of unwanted restarts, grey screens and update
            issues. So, while this one doesn’t sound fun, it is a much-needed fundamental change
            that will result in a smoother mobile experience for everyone.
          </div>

          <div className="whats-oplii-mobile--title">The smaller stuff:</div>

          <ul className="leastClass">
            <li>
              Some visual and functional changes to filters that make it easier to see and reset
              applied filters, save and edit bookmarks,
            </li>
            <li>
              The page you’re looking at now (coupled with the banner that shows you’ve updated the
              app) is brand new,
            </li>

            <li>Changes to ‘Due Date’ and ‘Scheduled Date’ filters to include overdue work,</li>

            <li>Allowing map-view bookmarks to reopen in map view instead of list view,</li>

            <li>And, finally, a number of bugs were fixed, of course.</li>
          </ul>
        </div>
      </div>

      {/* section 4 */}
      <div
        className={`whats-oplii-mobile ${style.updateInfoContainerLast}`}
        style={{ maxWidth: '768px', width: '100%' }}
      >
        <div className="whats-oplii-mobile--title">Version 1.4.22.0</div>
        <div className={style.yearAndMonth}>November 2024</div>

        <div className="whats-oplii-mobile--tidbits" style={{ paddingTop: '16px' }}>
          <div className="whats-oplii-mobile--title">Main feature: Auto-save!</div>
          <div className="whats-oplii-mobile--description">
            We’ve implemented an auto-save feature that saves your tasks as you work on them. That
            way, if something happens and Oplii Mobile crashes or is closed by accident, the task
            you were working on will be available in the ‘In Progress’ tab in your task listings.
          </div>

          <div className="whats-oplii-mobile--title"> The smaller stuff:</div>

          <ul className="leastClass">
            <li>
              When creating a new task, you’ll now see the task menu in the upper right corner,
              which gives you an easier way to save and close it (vs. hitting Back or Cancel),
            </li>
            <li>
              On Home, At-a-glance bookmarks (Home) are now presented vertically to make them easier
              to peruse,
            </li>

            <li>
              The Pin to ‘At a glance’ on home option when creating a new filter is now checked by
              default,
            </li>

            <li>A count of downloaded records are now shown the ‘Data refresh complete’ modal,</li>

            <li>On Home, a new Map button provides a shortcut to the sites list in map view,</li>

            <li>More information is shown when you open assigned checks,</li>

            <li>And, finally, a number of bugs were fixed, of course.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default UpdateAppInfo;
